import { LAYOUTS, } from '@voltmoney/types';
import { WIDGET } from '@voltmoney/schema';
import { ROUTE } from '../../../routes';
import { ACTION } from "./type";
import { goBack, navNext, needHelp } from "./action";
import { getApplicationId } from "../../../configs/utils";
import { api } from "../../../configs/api";
import { getAppHeader } from "../../../configs/config";
import SharedPropsService from '../../../SharedPropsService';
export const template = (height, offerSelectionInitData, lender) => ({
    layout: {
        id: ROUTE.LOAN_RENEWAL_VERIFY_SUMMARY_PAGE,
        type: LAYOUTS.LIST,
        style: {
            isPartnerPlatform: true
        },
        widgets: [
            { id: 'loanRenewalLearnMorePage', type: WIDGET.LOAN_RENEWAL_VERIFY_SUMMARY_PAGE }
        ],
    },
    datastore: {
        loanRenewalLearnMorePage: {
            offerSelectionInitData: offerSelectionInitData,
            loanExpiryDay: 7,
            penalInterest: 2,
            height: height,
            lender,
            isLoading: false,
            ctaAction: {
                type: ACTION.NAV_NEXT,
                routeId: ROUTE.LOAN_RENEWAL_VERIFY_SUMMARY_PAGE,
                payload: {}
            },
            needHelpAction: {
                routeId: ROUTE.LOAN_RENEWAL_VERIFY_SUMMARY_PAGE,
                type: ACTION.NEED_HELP,
                payload: { id: 'bt_getPortfolioScreen_needHelp_test' }
            },
            goBackAction: {
                routeId: ROUTE.LOAN_RENEWAL_VERIFY_SUMMARY_PAGE,
                type: ACTION.GO_BACK,
                payload: { id: 'bt_getPortfolioScreen_goBack_test_12' }
            },
        }
    },
});
export const loanRenewalVerifySummaryPage = {
    onLoad: async ({ network, getHeight }) => {
        const applicationId = await getApplicationId();
        let offerSelectionInitData;
        let user = await SharedPropsService.getUser();
        const lender = user.linkedApplications[0].lenderAccountId;
        const getOfferSelectionInitResponse = await network.get(`${api.getOfferSelectionInit}${applicationId}`, {
            headers: await getAppHeader()
        });
        if (getOfferSelectionInitResponse?.status === 200) {
            offerSelectionInitData = getOfferSelectionInitResponse?.data?.stepResponseObject;
        }
        return Promise.resolve(template(getHeight(), offerSelectionInitData, lender));
    },
    actions: {
        [ACTION.GO_BACK]: goBack,
        [ACTION.NEED_HELP]: needHelp,
        [ACTION.NAV_NEXT]: navNext,
    },
};
